import { ClickAwayListener } from '@mui/material'
import { Box } from '@mui/system'
import { array, bool, func, shape, string } from 'prop-types'
import ArrowheadDownIcon from '../../../../atoms/icons/arrowhead-down-icon'
import ArrowheadUpIcon from '../../../../atoms/icons/arrowhead-up-icon'
import Typography from '../../../../atoms/typography'
import BHTooltip from '../../../tooltip'
import WorkingTimes, { OpenNow } from './working-times'
import { Tooltip } from './working-times-table.styled'
import { useMemo } from 'react'

/**
 * TODO: 🧑🏻‍💻 refactor
 */
const WorkingTimesTable = ({ className, open, setOpen, workingTimes, workingTimeTooltipProps }) => {
	const workingTimesRendered = useMemo(() => WorkingTimes({ workingTimes }), [workingTimes])

	return workingTimes && workingTimesRendered ? (
		<ClickAwayListener onClickAway={() => setOpen(false)}>
			<Tooltip
				className={className}
				arrow={false}
				open={open}
				onClose={() => setOpen(false)}
				disableHoverListener
				disableTouchListener
				disableFocusListener
				title={workingTimesRendered}
				placement="bottom-start"
				PopperProps={{
					modifiers: [
						{
							name: 'flip',
							options: {
								enabled: false,
							},
						},
					],
				}}
				{...workingTimeTooltipProps}
			>
				<Box display="inline-flex" onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
					<Typography component="span">
						<OpenNow workingTimes={workingTimes} />
					</Typography>
					<Typography component="span">{open ? <ArrowheadUpIcon /> : <ArrowheadDownIcon />}</Typography>
				</Box>
			</Tooltip>
		</ClickAwayListener>
	) : null
}

WorkingTimesTable.defaultProps = {
	open: false,
}
WorkingTimesTable.propTypes = {
	/**
	 * Defines className for root node.
	 */
	className: string,
	/**
	 * Whether the table is open or not.
	 */
	open: bool.isRequired,
	/**
	 * Callback to manage the open state of the tooltip.
	 */
	setOpen: func.isRequired,
	/**
	 * Working times.
	 */
	workingTimes: array.isRequired,
	/**
	 * Props to pass to the tooltip that renders the working times of the stores.
	 */
	workingTimeTooltipProps: shape({ ...BHTooltip.propTypes }),
}
export default WorkingTimesTable
